import React from 'react';

// Components
import Loader from 'components/UiKit/Loader';
import CartPfizer from 'components/Carts/CartPfizer';

// Lib
import { shallowEqual } from 'react-redux';
import { useAppSelector } from 'lib/hooks/useDispatch';

export const Container: React.FC = () => {
	const {
		data,
		loading
	} = useAppSelector(
		(store) => {
			return {
				data: store.moleculeProduct.relatedCompounds,
				loading: store.moleculeProduct.relatedCompoundsLoading
			};
		},
		shallowEqual
	);

	return <div className="related-compounds">
		{!!data?.length && <h4 className="related-compounds__title">Related Compounds</h4>}
		<div className="related-compounds__content">
			{loading
				? <div className="related-compounds__loader-dna relative full-width flex flex-ai-center flex-jc-center">
					<Loader
						color="white"
						type="small"
					/>
				</div>
				: data?.map((item: any) => {
					return <CartPfizer
						key={item.id}
						{...item}
						type="cart"
						offAllFunctions
						currentTypePrice="EBC"
						classNameWrapper="mb10"
					/>;
				})}
		</div>
	</div>;
};

export default Container;